"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paintsUsed = exports.paintOf = void 0;
exports.surfaceHours = surfaceHours;
exports.byPaint = byPaint;
const takeoff_layout_ts_1 = require("./takeoff-layout.js");
/** Paints besides the option's first (slot 0, which sundries use) one workbook holds. */
const OTHER_PAINT_SLOTS = takeoff_layout_ts_1.PAINT_SLOTS.length - 1;
/** A surface row's hours for one building, as pricing.ts works them out. */
function surfaceHours(s) {
    const paint = s.rate > 0 ? (s.quantity * s.coats) / s.rate : 0;
    const prep = s.prep > 0 ? s.quantity / s.prep : 0;
    return (paint + prep) * (1 + (s.uplift ?? 0));
}
const paintOf = (row, rates) => row.paintId ?? rates.paints[0]?.id ?? '';
exports.paintOf = paintOf;
/** The paints an area's surfaces use. */
const paintsUsed = (section, rates) => new Set(section.input.surfaces.map((s) => (0, exports.paintOf)(s, rates)));
exports.paintsUsed = paintsUsed;
/**
 * An area using more paints than one workbook's six slots, as parts that each
 * fit: the first part keeps the option's first paint, the area's extras (wash,
 * sundries, hire, other trades) and its notes; each later part takes the
 * surfaces of the next five paints and carries on in the next workbook.
 * Approved hours stay whole: the first part's are the area's less the later
 * parts' own hours, so the adjustment is the same.
 */
function byPaint(section, rates) {
    const first = rates.paints[0]?.id ?? '';
    const others = [...(0, exports.paintsUsed)(section, rates)].filter((p) => p !== first);
    if (others.length <= OTHER_PAINT_SLOTS)
        return [section];
    const groups = Array.from({ length: Math.ceil(others.length / OTHER_PAINT_SLOTS) }, (_, i) => others.slice(i * OTHER_PAINT_SLOTS, (i + 1) * OTHER_PAINT_SLOTS));
    const input = section.input;
    const owner = (row) => input.surfaces.find((s) => s.id === row.systemOf);
    const partOf = (row) => Math.max(0, groups.findIndex((g) => g.includes((0, exports.paintOf)(row, rates))));
    const later = input.surfaces.filter((s) => partOf(s) > 0);
    return groups.map((_, i) => {
        if (i === 0) {
            const approvedHours = typeof input.approvedHours === 'number' ? input.approvedHours - later.reduce((sum, s) => sum + surfaceHours(s), 0) : input.approvedHours;
            return { ...section, input: { ...input, approvedHours, surfaces: input.surfaces.filter((s) => partOf(s) === 0) } };
        }
        // A paint system away from its surface's part is named for it, since its surface's row is elsewhere.
        const surfaces = input.surfaces
            .filter((s) => partOf(s) === i)
            .map((s) => (s.systemOf && partOf(owner(s) ?? s) !== i ? { ...s, systemOf: undefined, name: `${owner(s)?.name ?? ''} – ${s.name}` } : s));
        const rest = { id: input.id, name: input.name, surfaces, buildingCount: input.buildingCount, downtime: input.downtime, overtime: input.overtime, foreman: input.foreman, abseil: input.abseil, consumablesRate: input.consumablesRate, washRate: input.washRate };
        return { ...section, input: rest, exclusions: null, notes: null, continued: true };
    });
}
